import { Deserializable } from '../_common/deserializable';

export class AdvertiserAffiliate implements Deserializable {
  id: number;
  advertiserId: number;
  affiliate: string;
  min: number;
  rate: number;
  max: number;
  url: string;
  customizedUrl: string;
  updatedAt: number;
  createdAt: number;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}
